"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _deliverySetting = require("@/api/rensou/deliverySetting");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function createDefaultTemp() {
  return {
    id: null,
    templateName: '',
    areaType: '半径',
    riderPhone: '',
    deliveryType: 1,
    deliveryChannel: '',
    autoOrder: 1,
    maxDeliveryRadius: '',
    maxAcceptOrderTime: '',
    freeDeliveryRadius: '',
    freeDeliveryThreshold: '',
    startPrice: '',
    excessPrice: 0,
    perKilometerTime: 0,
    sort: 0,
    deliveryMethods: '1',
    reservationLimit: 0,
    timeSlotList: [{
      timeRange: ['09:00', '16:00']
    }],
    status: 1
  };
}
var _default2 = exports.default = {
  name: 'DeliveryFormDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    dialogStatus: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      temp: createDefaultTemp(),
      deliveryMethodOptions: [{
        value: '1',
        label: '立即送出',
        selected: true
      }, {
        value: '2',
        label: '预约配送',
        selected: false
      }],
      initializingForm: false,
      platformDefaultTemplate: null,
      existingTemplateNames: [],
      rules: {
        templateName: [{
          required: true,
          message: '请输入模板名称',
          trigger: 'blur'
        }, {
          validator: this.validateTemplateName,
          trigger: 'blur'
        }],
        deliveryChannel: [{
          validator: this.validateDeliveryChannel,
          trigger: 'change'
        }],
        maxAcceptOrderTime: [{
          validator: this.validateMaxAcceptOrderTime,
          trigger: ['blur', 'change']
        }],
        maxDeliveryRadius: [{
          required: true,
          message: '请输入最大配送半径',
          trigger: 'blur'
        }],
        freeDeliveryRadius: [{
          validator: this.validateFreeRadius,
          trigger: 'blur'
        }, {
          required: true,
          message: '请输入免配送费半径',
          trigger: 'blur'
        }],
        freeDeliveryThreshold: [{
          validator: this.validateFreeThreshold,
          trigger: 'blur'
        }],
        startPrice: [{
          required: true,
          message: '请输入起步价',
          trigger: 'blur'
        }, {
          validator: this.validateStartPrice,
          trigger: 'blur'
        }],
        deliveryMethods: [{
          required: true,
          message: '请至少选择一种配送方式',
          trigger: 'change'
        }]
      }
    };
  },
  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(value) {
        this.$emit('update:visible', value);
      }
    },
    hasReservationDelivery: function hasReservationDelivery() {
      var deliveryMethods = String(this.temp.deliveryMethods || '');
      return this.deliveryMethodOptions[1].selected || deliveryMethods.includes('2');
    },
    isPlatformDelivery: function isPlatformDelivery() {
      return Number(this.temp.deliveryType) === 1;
    },
    reservationDeliveryWatcher: function reservationDeliveryWatcher() {
      return this.hasReservationDelivery;
    }
  },
  watch: {
    formData: {
      handler: function handler(val) {
        var _this = this;
        if (val && Object.keys(val).length > 0) {
          this.initializingForm = true;
          var processedData = _objectSpread({}, val);
          processedData.timeSlotList = this.parseTimeSlots(processedData.timeSlotList);
          processedData.maxAcceptOrderTime = this.normalizeMaxAcceptOrderTime(processedData.maxAcceptOrderTime);
          var dt = Number(processedData.deliveryType);
          if (dt === 1) {
            var ch = processedData.deliveryChannel;
            processedData.deliveryChannel = ch === 1 || ch === 2 || ch === '1' || ch === '2' ? String(ch) : '';
          }
          this.temp = Object.assign({}, createDefaultTemp(), processedData);
          if (processedData.deliveryMethods) {
            this.parseDeliveryMethods(processedData.deliveryMethods);
            this.updateDeliveryMethods();
          } else {
            this.resetDeliveryMethodOptions();
          }
          this.syncDeliveryTypeConfig(processedData.deliveryType, null);
          this.$nextTick(function () {
            _this.initializingForm = false;
          });
        }
      },
      immediate: true,
      deep: true
    },
    reservationDeliveryWatcher: {
      handler: function handler(newVal) {
        if (newVal && (!this.temp.timeSlotList || this.temp.timeSlotList.length === 0)) {
          this.$set(this.temp, 'timeSlotList', [{
            timeRange: ['09:00', '16:00']
          }]);
        }
      },
      immediate: false
    },
    'temp.autoOrder': {
      handler: function handler(newVal) {
        var _this2 = this;
        if (this.initializingForm) {
          return;
        }
        if (Number(newVal) === 1) {
          this.$set(this.temp, 'maxAcceptOrderTime', '');
          this.$nextTick(function () {
            _this2.$refs.dataForm && _this2.$refs.dataForm.clearValidate(['maxAcceptOrderTime']);
          });
        } else if (Number(newVal) === 2) {
          if (this.isPlatformDelivery) {
            this.applyPlatformDefaultConfig();
          } else if (this.temp.maxAcceptOrderTime == null || this.temp.maxAcceptOrderTime === '') {
            this.$set(this.temp, 'maxAcceptOrderTime', '');
          }
        }
      },
      immediate: false
    },
    'temp.deliveryType': function tempDeliveryType(val, oldVal) {
      var _this3 = this;
      if (this.initializingForm) {
        return;
      }
      if (Number(val) !== 1) {
        this.$set(this.temp, 'deliveryChannel', '');
        this.$nextTick(function () {
          _this3.$refs.dataForm && _this3.$refs.dataForm.clearValidate(['deliveryChannel']);
        });
      }
      this.syncDeliveryTypeConfig(val, oldVal);
    }
  },
  created: function created() {
    this.fetchExistingTemplateNames();
  },
  methods: {
    getDefaultTimeSlotList: function getDefaultTimeSlotList() {
      return [{
        timeRange: ['09:00', '16:00']
      }];
    },
    resetDeliveryMethodOptions: function resetDeliveryMethodOptions() {
      this.deliveryMethodOptions[0].selected = true;
      this.deliveryMethodOptions[1].selected = false;
    },
    normalizeMaxAcceptOrderTime: function normalizeMaxAcceptOrderTime(value) {
      if (value === '' || value === null || value === undefined) {
        return '';
      }
      var num = Number(value);
      return isNaN(num) ? '' : num;
    },
    validateMaxAcceptOrderTime: function validateMaxAcceptOrderTime(rule, value, callback) {
      if (Number(this.temp.autoOrder) !== 2) {
        callback();
        return;
      }
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入最大等待接单时间'));
        return;
      }
      var num = Number(value);
      if (isNaN(num) || num < 1) {
        callback(new Error('最大等待接单时间必须大于0'));
        return;
      }
      callback();
    },
    validateDeliveryChannel: function validateDeliveryChannel(rule, value, callback) {
      if (Number(this.temp.deliveryType) !== 1) {
        callback();
        return;
      }
      var channel = String(value || '');
      if (channel === '') {
        callback(new Error('请选择配送渠道'));
        return;
      }
      if (!['1', '2'].includes(channel)) {
        callback(new Error('配送渠道仅支持达达或顺丰'));
        return;
      }
      callback();
    },
    handleDialogOpen: function handleDialogOpen() {
      var _this4 = this;
      if (this.dialogStatus === 'create') {
        this.initializingForm = true;
        this.resetForm();
        this.syncDeliveryTypeConfig(this.temp.deliveryType, null);
        this.$nextTick(function () {
          _this4.initializingForm = false;
        });
      }
    },
    getPlatformManagedValidateFields: function getPlatformManagedValidateFields() {
      return ['maxAcceptOrderTime', 'maxDeliveryRadius', 'freeDeliveryRadius', 'freeDeliveryThreshold', 'startPrice'];
    },
    clearPlatformManagedConfig: function clearPlatformManagedConfig() {
      this.temp.maxAcceptOrderTime = Number(this.temp.autoOrder) === 2 ? '' : null;
      this.temp.maxDeliveryRadius = '';
      this.temp.freeDeliveryRadius = '';
      this.temp.freeDeliveryThreshold = '';
      this.temp.startPrice = '';
      this.temp.excessPrice = 0;
      this.temp.perKilometerTime = 0;
      this.temp.reservationLimit = 0;
      this.temp.timeSlotList = this.hasReservationDelivery ? this.getDefaultTimeSlotList() : [];
    },
    ensurePlatformDefaultTemplate: function () {
      var _ensurePlatformDefaultTemplate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var response;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!this.platformDefaultTemplate) {
                _context.n = 1;
                break;
              }
              return _context.a(2, this.platformDefaultTemplate);
            case 1:
              _context.n = 2;
              return (0, _deliverySetting.getDeliveryTemplateInfo)(1);
            case 2:
              response = _context.v;
              this.platformDefaultTemplate = _objectSpread(_objectSpread({}, response), {}, {
                timeSlotList: Array.isArray(response.timeSlotList) && response.timeSlotList.length > 0 ? this.parseTimeSlots(response.timeSlotList) : []
              });
              return _context.a(2, this.platformDefaultTemplate);
          }
        }, _callee, this);
      }));
      function ensurePlatformDefaultTemplate() {
        return _ensurePlatformDefaultTemplate.apply(this, arguments);
      }
      return ensurePlatformDefaultTemplate;
    }(),
    applyPlatformDefaultConfig: function () {
      var _applyPlatformDefaultConfig = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this5 = this;
        var defaultTemplate, _t;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return this.ensurePlatformDefaultTemplate();
            case 1:
              defaultTemplate = _context2.v;
              if (this.isPlatformDelivery) {
                _context2.n = 2;
                break;
              }
              return _context2.a(2);
            case 2:
              this.temp.maxAcceptOrderTime = Number(this.temp.autoOrder) === 2 ? defaultTemplate.maxAcceptOrderTime : null;
              this.temp.maxDeliveryRadius = defaultTemplate.maxDeliveryRadius;
              this.temp.freeDeliveryRadius = defaultTemplate.freeDeliveryRadius;
              this.temp.freeDeliveryThreshold = defaultTemplate.freeDeliveryThreshold;
              this.temp.startPrice = defaultTemplate.startPrice;
              this.temp.excessPrice = defaultTemplate.excessPrice;
              this.temp.perKilometerTime = defaultTemplate.perKilometerTime;
              this.temp.reservationLimit = defaultTemplate.reservationLimit || 0;
              this.temp.timeSlotList = defaultTemplate.timeSlotList && defaultTemplate.timeSlotList.length > 0 ? defaultTemplate.timeSlotList.map(function (slot) {
                return {
                  timeRange: _toConsumableArray(slot.timeRange)
                };
              }) : [];
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t = _context2.v;
              this.$message.error(_t.message || '获取默认配送配置失败');
            case 4:
              _context2.p = 4;
              this.$nextTick(function () {
                _this5.$refs.dataForm && _this5.$refs.dataForm.clearValidate(_this5.getPlatformManagedValidateFields());
              });
              return _context2.f(4);
            case 5:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 3, 4, 5]]);
      }));
      function applyPlatformDefaultConfig() {
        return _applyPlatformDefaultConfig.apply(this, arguments);
      }
      return applyPlatformDefaultConfig;
    }(),
    syncDeliveryTypeConfig: function syncDeliveryTypeConfig(newVal, oldVal) {
      var _this6 = this;
      var nextType = Number(newVal);
      var prevType = Number(oldVal);
      if (nextType === prevType) {
        return;
      }
      if (nextType === 1) {
        this.applyPlatformDefaultConfig();
        return;
      }
      if (prevType === 1) {
        this.clearPlatformManagedConfig();
        this.$nextTick(function () {
          _this6.$refs.dataForm && _this6.$refs.dataForm.clearValidate(_this6.getPlatformManagedValidateFields());
        });
      }
    },
    validateTemplateName: function validateTemplateName(rule, value, callback) {
      if (!value) {
        callback();
        return;
      }
      if (this.dialogStatus === 'update' && this.formData.templateName === value) {
        callback();
        return;
      }
      if (this.existingTemplateNames.includes(value)) {
        callback(new Error('模板名称已存在，请更换名称'));
      } else {
        callback();
      }
    },
    validateFreeRadius: function validateFreeRadius(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      var freeRadius = Number(value);
      var maxRadius = Number(this.temp.maxDeliveryRadius);
      if (isNaN(freeRadius) || freeRadius < 0) {
        callback(new Error('免配送半径费不能小于0'));
      } else if (maxRadius && freeRadius > maxRadius) {
        callback(new Error('免配送半径费不能大于最大配送半径'));
      } else {
        callback();
      }
    },
    validateFreeThreshold: function validateFreeThreshold(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      var threshold = Number(value);
      if (isNaN(threshold) || threshold < 0) {
        callback(new Error('免配送门槛不能小于0'));
      } else {
        callback();
      }
    },
    validateStartPrice: function validateStartPrice(rule, value, callback) {
      if (value === '' || value === null || value === undefined) {
        callback();
        return;
      }
      var price = Number(value);
      if (isNaN(price) || price < 0) {
        callback(new Error('起步价不能小于0'));
      } else {
        callback();
      }
    },
    fetchExistingTemplateNames: function fetchExistingTemplateNames() {
      this.existingTemplateNames = ['测试模板1', '测试模板2', '测试模板3'];
    },
    formatTimeSlots: function formatTimeSlots(timeSlotList) {
      return timeSlotList.filter(function (slot) {
        return slot.timeRange && slot.timeRange.length === 2;
      }).map(function (slot) {
        return "".concat(slot.timeRange[0], "-").concat(slot.timeRange[1]);
      });
    },
    parseTimeSlots: function parseTimeSlots(timeSlotList) {
      if (!Array.isArray(timeSlotList) || timeSlotList.length === 0) {
        return [{
          timeRange: ['09:00', '16:00']
        }];
      }
      var parsedSlots = timeSlotList.map(function (timeSlot) {
        if (typeof timeSlot === 'string' && timeSlot.includes('-')) {
          var _timeSlot$split = timeSlot.split('-'),
            _timeSlot$split2 = _slicedToArray(_timeSlot$split, 2),
            start = _timeSlot$split2[0],
            end = _timeSlot$split2[1];
          return {
            timeRange: [start, end]
          };
        } else if (timeSlot.timeRange && Array.isArray(timeSlot.timeRange)) {
          return timeSlot;
        } else {
          return {
            timeRange: ['09:00', '16:00']
          };
        }
      });
      return parsedSlots.length > 0 ? parsedSlots : [{
        timeRange: ['09:00', '16:00']
      }];
    },
    parseDeliveryMethods: function parseDeliveryMethods(deliveryMethods) {
      var _this7 = this;
      if (!deliveryMethods) return;
      this.deliveryMethodOptions.forEach(function (option) {
        option.selected = false;
      });
      var methodValues = [];
      if (typeof deliveryMethods === 'string') {
        methodValues = deliveryMethods.split(',');
      } else if (Array.isArray(deliveryMethods)) {
        methodValues = deliveryMethods;
      } else {
        methodValues = [String(deliveryMethods)];
      }
      methodValues.forEach(function (value) {
        var option = _this7.deliveryMethodOptions.find(function (opt) {
          return opt.value === value;
        });
        if (option) {
          option.selected = true;
        }
      });
    },
    updateDeliveryMethods: function updateDeliveryMethods() {
      var selectedValues = this.deliveryMethodOptions.filter(function (option) {
        return option.selected;
      }).map(function (option) {
        return option.value;
      });
      this.temp.deliveryMethods = selectedValues.join(',');
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.resetForm();
    },
    handleConfirm: function handleConfirm() {
      var _this8 = this;
      this.$refs.dataForm.validate(function (valid) {
        if (valid) {
          var formData = _objectSpread({}, _this8.temp);
          if (Number(formData.deliveryType) !== 1) {
            delete formData.deliveryChannel;
          } else {
            formData.deliveryChannel = formData.deliveryChannel === '' || formData.deliveryChannel == null ? null : Number(formData.deliveryChannel);
          }
          if (Number(formData.autoOrder) !== 2) {
            formData.maxAcceptOrderTime = null;
          } else {
            formData.maxAcceptOrderTime = Number(formData.maxAcceptOrderTime);
          }
          if (!_this8.hasReservationDelivery) {
            formData.timeSlotList = [];
            formData.reservationLimit = 0;
          } else {
            formData.timeSlotList = _this8.formatTimeSlots(_this8.temp.timeSlotList);
          }
          var apiCall = _this8.dialogStatus === 'create' ? (0, _deliverySetting.createDeliveryTemplate)(formData) : (0, _deliverySetting.updateDeliveryTemplate)(formData);
          apiCall.then(function () {
            _this8.$message({
              type: 'success',
              message: _this8.dialogStatus === 'create' ? '添加成功!' : '更新成功!'
            });
            _this8.dialogVisible = false;
            _this8.$emit('refresh');
            _this8.resetForm();
          }).catch(function (error) {
            _this8.$message({
              type: 'error',
              message: error.message || (_this8.dialogStatus === 'create' ? '添加失败!' : '更新失败!')
            });
          });
        }
      });
    },
    resetForm: function resetForm() {
      var _this9 = this;
      this.temp = createDefaultTemp();
      if (this.dialogStatus === 'update' && this.formData && this.formData.id) {
        this.temp.id = this.formData.id;
      }
      this.resetDeliveryMethodOptions();
      this.$nextTick(function () {
        _this9.$refs.dataForm && _this9.$refs.dataForm.clearValidate();
      });
    },
    addTimeSlot: function addTimeSlot() {
      if (!this.temp.timeSlotList) {
        this.$set(this.temp, 'timeSlotList', []);
      }
      this.temp.timeSlotList.push({
        timeRange: ['09:00', '18:00']
      });
    },
    removeTimeSlot: function removeTimeSlot(index) {
      this.temp.timeSlotList.splice(index, 1);
    },
    showReservationTips: function showReservationTips() {
      this.$notify({
        title: '可预约时间说明',
        message: "\n          <div style=\"padding: 5px 0;\">\n            <p><strong>\u53EF\u9884\u7EA6\u65F6\u95F4</strong>\u8868\u793A\u7528\u6237\u53EF\u4EE5\u63D0\u524D\u591A\u5C11\u5929\u8FDB\u884C\u9884\u7EA6\u3002</p>\n            <p>\u4F8B\u5982\uFF1A</p>\n            <ul>\n              <li>\u9ED8\u8BA4\u4E3A0\uFF0C\u53EA\u80FD\u9884\u7EA6\u5F53\u5929\u7684\u65F6\u95F4</li>\n              <li>\u5982\u679C\u4E3A1\u5219\u53EF\u9884\u7EA6\u660E\u5929\u7684\u65F6\u95F4\uFF0C\u4EE5\u6B64\u7C7B\u63A8</li>\n            </ul>\n          </div>\n        ",
        duration: 6000,
        dangerouslyUseHTMLString: true,
        type: 'info',
        position: 'bottom-right'
      });
    }
  }
};